import React from "react"
import moment from "moment"

import Tags from "../../common/tags/Tags"
import TagItem from "../../common/tags/TagItem"
import NotificationStatus from "../NotificationStatus"
import { getDisplayTagFromType } from "../util"

const NotificationsListItem = ({
    id,
    activeId,
    title,
    message,
    type,
    expires,
    not_before,
    onClick,
}) => (
    <div
        className={`list-group-item${
            activeId === id ? " active" : ""
        } source-list-item`}
        onClick={onClick ? onClick(id) : null}
    >
        <div
            className="list-group-item-content"
            style={{ paddingLeft: "10px", paddingRight: "10px" }}
        >
            <h4>{title}</h4>
            <p className="source-description text-shorten-single-line">
                {message}
            </p>
            <NotificationStatus
                style={{ right: "10px" }}
                expires={expires ? moment(expires * 1000) : null}
                not_before={not_before ? moment(not_before * 1000) : null}
            />
            {type && (
                <Tags>
                    <TagItem isGrey={true}>
                        {getDisplayTagFromType(type)}
                    </TagItem>
                </Tags>
            )}
        </div>
    </div>
)

export default NotificationsListItem
